export const obsRestEndpointUri = async (isMicroservice = false) => {
  return isMicroservice ? '' : process.env.OBS_REST_ENDPOINT_URI || '';
};
